<div class ="validation-wizard">
<div class = "validation-file-viewer ">
<ispm-event-content-file-viewer
        [ngStyle]="{'width': config?.middlePanel?.width}"
        [ngClass]="{'full-width-height': !showDataCaptureSection}"
        [selectedEvent]="selectedEvent"
        [isEditable]="false"
        [eventDefinition]="eventDefinition"
        [nlpConfig]="config.nlpConfiguration"
        [addReportAvailable]="addReportAvailable"
        [eventFileIdList]="eventFileIdList"
        [reviewExtractionKey]="reviewExtractionKey"
        [findingData]="findingDataArr"
        >
</ispm-event-content-file-viewer>
</div>
<section class="validation-findings ">
    <div class ="header">
        <gen-button *ngIf="currentFinding>0"
                    [iconClass]="'icon__arrow_left'"
                    [type]="'quite'"
                    (click)="loadPreviousFinding()"></gen-button>{{headerConfig?.showCurrentFindings ? displayCurrentFinding :"" }}/{{headerConfig?.showTotalFindings ? totalReviewData :"" }} {{headerConfig?.label ? wizardLabel: ""}}

    </div>
    <div class="finding-form">
    <gen-dynamic-form
                      [formData] = findingsData
                      [formName]="formId"
                      [popupMode]="true"
                      [editMode]="true"
                      [disabled]="false"
                      [formVertical]="false"
                      [listenToDataChange]="true"
                      (formChange)="getPerFindingDataUpdate($event.form)"
                      [submitted]="isDataUpdated? true:false"

    ></gen-dynamic-form>
    </div>
    <div class="wizard-controls">
    <ng-container  *ngFor="let action of actionItems" class="event-ribbon-buttons">
        <gen-button  [type]="'secondary'"
                     (click)="performAction(action)"
                     [iconClass]="action?.iconClass"
                     [text]="action?.name"
                     [ngClass]="action?.name == 'Close'?'gen-button-close':'event-ribbon-buttons'"
        ></gen-button>
    </ng-container>

        <ng-container *ngIf="currentFinding === (totalReviewData - 1); else isNext">
            <gen-button
                    [type]="'primary'"
                    (click)="confirmExtraction()"
                    [iconClass]="'modal-action Auto_Popup_Action_Button Next_button'"
                    [text]="'Confirm Extraction'"
                    [ngClass]="'gen-button-confirm-extraction'"
            ></gen-button>
        </ng-container>
        <ng-template #isNext>
            <ng-container *ngIf="isDataUpdated; else next">
                <gen-button
                        [type]="'primary'"
                        (click)="saveAndLoadNextFinding()"
                        [iconClass]="'modal-action Auto_Popup_Action_Button Next_button'"
                        [text]="'Save and Next'"
                        [ngClass]="'gen-button-save-and-next'"
                ></gen-button>
            </ng-container>
            <ng-template #next>
                <gen-button
                        [type]="'primary'"
                        (click)="loadNextFinding()"
                        [iconClass]="'modal-action Auto_Popup_Action_Button Next_button'"
                        [text]="'Next'"
                        [ngClass]="'gen-button-next'"
                ></gen-button>
            </ng-template>
        </ng-template>
    </div>
</section>
</div>

